import { ContaBancaria, DadosAssociadoApi } from "#/types";
import { request } from "#/utils/request";

/** Endpoints */
export const ENDPOINT_ASSOCIADO = "/associados";
export const ENDPOINT_ASSOCIADO_DADOS_PESSOAIS = `${ENDPOINT_ASSOCIADO}/dados/pessoais`;
export const ENDPOINT_ASSOCIADO_VALIDA_CONTA = `${ENDPOINT_ASSOCIADO}/valida/conta`;

/**
 * @function consultarDadosAssociado - consulta os dados basicos do associado
 */
export const consultarDadosAssociado = async () =>
  (await request.get<DadosAssociadoApi>(ENDPOINT_ASSOCIADO_DADOS_PESSOAIS))
    .data;

/**
 * @function validaContaAssociado - valida se os dados bancarios pertencem ao associado
 */
export const validaContaAssociado = async (dadosConta: ContaBancaria) =>
  (
    await request.get<boolean>(ENDPOINT_ASSOCIADO_VALIDA_CONTA, {
      params: dadosConta,
    })
  ).data;
